import { createContext, useContext, useState, useCallback } from 'react';

const BackgroundContext = createContext(null);

/**
 * Lets a page temporarily override the App-level scrolling background image
 * (the partyland animation) with its own image. Used by ClubPage so a club's
 * custom background fully replaces the global site background while you're on
 * that page, and reverts when you navigate away.
 */
export function BackgroundProvider({ children }) {
  const [overrideUrl, setOverrideUrlState] = useState(null);

  // Stable setter so consumers can put it in a useEffect dependency array
  // without retriggering on every render.
  const setOverrideUrl = useCallback((url) => {
    setOverrideUrlState(url || null);
  }, []);

  return (
    <BackgroundContext.Provider value={{ overrideUrl, setOverrideUrl }}>
      {children}
    </BackgroundContext.Provider>
  );
}

export function useBackground() {
  const ctx = useContext(BackgroundContext);
  if (!ctx) throw new Error('useBackground must be used within a BackgroundProvider');
  return ctx;
}

export default BackgroundContext;
